import { ExamFormStatusType } from "@rmh/defs";

interface ExamFormStatusTagProps {
  status?: ExamFormStatusType;
  className?: string;
}

const STATUS_MAP = {
  [ExamFormStatusType.Completed]: {
    color: "text-rmh-green-700",
    text: "Completed"
  },
  [ExamFormStatusType.Deleted]: {
    color: "text-rmh-red-600",
    text: "Deleted"
  },
  [ExamFormStatusType.InProgress]: {
    color: "text-rmh-orange-500",
    text: "In Progress"
  },
  [ExamFormStatusType.Incomplete]: {
    color: "text-rmh-orange-500",
    text: "Incomplete"
  },
  [ExamFormStatusType.NotStarted]: {
    color: "text-rmh-gray-500",
    text: "Not Started"
  },
}

const ExamFormStatusTag = ({status, className}: ExamFormStatusTagProps) => {
  if (!status) {
    return null;
  }

  const style = className ?? "body-m";
  return <p className={`${style} ${STATUS_MAP[status].color}`}>{STATUS_MAP[status].text}</p>
}

export default ExamFormStatusTag;